module.exports = __webpack_public_path__ + "static/media/3d-space-1.ab3882d8.png";